/**
 * 是否购买增值服务下的接口
 */
import { _get, _post, _put } from '@/common/request';
// 判断是否是专业版
export function getIsProfessional(params) {
    return _get('/property/professional/verify', params, true);
}
// 是否申请过开通专业版
export function getApplyProfessional(params) {
    return _get('/property/service/professional/status', params, true);
}
// 获取专业版价格
export function getProfessionalPrice(params) {
    return _get('/property/professional/price', params, true);
}
// 邀请码升级为专业版
export function inviteToProfessional(params) {
    return _put('/property/profession/invite', params, true);
}
// 购买专业版
export function purchaseProfessional(params) {
    return _post('/property/service/buy', params, true);
}
// 支付宝回调
export function alipayCallback(params) {
    return _get('/property/pay/alipay/notify', params, true);
}
// 查询微信支付状态
export function getWechatPayStatus(params) {
    return _get('/property/pay/status', params, true);
}
